export const APPOINTMENT_TYPES: Record<string, common.AppointmentType> = {
  engineer: 'Engineer appointment',
  expert: 'Expert set up appointment',
  broadband: 'Broadband engineer appointment',
};

export const OPENREACH_APPOINTMENT_TYPES = [
  APPOINTMENT_TYPES.engineer,
  APPOINTMENT_TYPES.broadband,
];
